import React from 'react';
import './styles/reviewCard.css';

const ReviewCard = ({ review, renderStars }) => {
  return (
    <div className="review-card">
      <div className="review-content">
        <div className="review-stars">{renderStars(review.rating)}</div>
        <p className="review-text">{review.comment}</p>
        <div className="review-author">
          <span className="author-name">{review.name}</span>
          <span className="review-date">{review.date}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
